<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <b>Inativar</b>
        </p>
        <button type="button" class="delete" @click="cancel" />
      </header>
      <section class="modal-card-body">
        <p>
          Deseja realmente inativar ?
        </p>
        <br />
      </section>
      <footer class="modal-card-foot">
        <b-button
          native-type="button"
          type="is-danger"
          outlined
          @click="cancel"
        >
          Cancelar
        </b-button>
        <b-button type="is-danger" @click="confirmar"> Confirmar </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalDelete",
  props: {
    isActive: Boolean,
    item: Object, 
  },
  emits: ["cancel", "confirm"],
  data() {
    return {
      isModalActive: this.isActive, // Controla a visibilidade do modal
    };
  },
  methods: {
    confirmar(){
        this.$emit("confirm", this.item.id);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  watch: {
    isActive(newVal) {
      this.isModalActive = newVal; // Sincroniza o estado do modal com a prop isActive
    },
  }
});
</script>
